import React,{useState,useEffect} from 'react'
import { SecurityPolicySec } from './securityPolicySec'

export const SecurityPolicy = () => {
    return (
        <>
         <SecurityPolicySec />
        </>
    )
}